import { render, staticRenderFns } from "./DashboardNavbarDetail.vue?vue&type=template&id=3c565846"
import script from "./DashboardNavbarDetail.vue?vue&type=script&lang=js"
export * from "./DashboardNavbarDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports